import React from "react";
import { COMPANY } from "@/lib/apiClient";

export const Logo = ({ size = 64, showText = true }) => (
  <div className="flex items-center gap-4" data-testid="brand-logo">
    <div
      className="rounded-2xl overflow-hidden ring-1 ring-blue-400/30 shrink-0 bg-slate-900"
      style={{ width: size, height: size }}
    >
      <img
        src={COMPANY.logo}
        alt="PAS Percetakan"
        className="w-full h-full object-cover"
      />
    </div>
    {showText && (
      <div className="leading-tight">
        <div className="font-display font-bold text-lg md:text-xl metal-text tracking-wide">
          {COMPANY.name}
        </div>
        <div className="text-[10px] md:text-xs uppercase tracking-[0.18em] text-slate-400">
          {COMPANY.tagline}
        </div>
      </div>
    )}
  </div>
);
